import React, { Children, useEffect, useRef, useState } from "react";
import { addFaq, updateFaq } from "../../actions/utilitiesAction";
import constant from "../../constant";
import QualificationLists from "../../component/jobs/QualificationList";
import { archiveEducationQualification, archiveFunctionalarea, createEducationQualification, createRole, functionalareaList, updateEducationQualification, updateRole } from "../../actions/JobsAction";
import QuestionLists from "../../component/jobs/QuestionList";
import RoleLists from "../../component/jobs/RoleList";
import AddRoles from "../../component/jobs/AddRole";
import AddFunctionalAreas from "../../component/jobs/AddFunctionalArea";
import FunctionalAreaLists from "../../component/jobs/FunctionalAreaList";
import { useLocation } from "react-router-dom";
import queryString from "query-string"

const FunctionalAreaList = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [count, setCount] = useState(0)
    const [functionalList, setsetFunctionalList] = useState([]);
    const location = useLocation()


    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getFuncAreaList(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage);
    }, [currentPage]);


    const getFuncAreaList = (page) => {
        functionalareaList({ pageNumber: page })
            .then((res) => {
                if (res.status) {
                    setCount(res.result.count);
                    setsetFunctionalList(res.result.list);
                }
            })
            .catch((err) => {
                alert(err);
            });
    };

    const updateStatus = (model) => {
        archiveFunctionalarea(model).then((res) => {
            if (res.status) {
                getFuncAreaList(currentPage);
            }
            else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }


    return (
        <React.Fragment>
            <FunctionalAreaLists
                functionalList={functionalList}
                updateStatus={updateStatus}
                getFuncAreaList={(page => getFuncAreaList(page))}
                count={count} setPage={setCurrentPage}
                cpage={currentPage}
            />
        </React.Fragment>
    )
}

export default FunctionalAreaList;